// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"idt-gridcontainer_gridcontainer__2pbaj"};